import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";

import { notification } from "../../../services/helpers";
import { cardRechargeRequest, checkUserPlanProgram } from "../../requests";
import { STEPS_NAME, parseCurrency, parseMsisdn } from "../../utils";

import { baseAPI } from "../../../services/api";
import * as Styles from "./styles";

export const parseCentsToBRL = (value) => {
  const moneyFormatter = (Number(value) / 100).toLocaleString("pt-br", {
    style: "currency",
    currency: "BRL",
  });
  return moneyFormatter.normalize("NFKC");
};

export function PaymentCardReceipt({
  plan,
  msisdn,
  paymentData,
  onChangeStep,
  onPayment,
  authToken,
  setIsLoading,
  allowChangeData,
  canMakeProgram,
  infoMessage,
  successMessage = "Sua recarga foi realizada com sucesso. Em alguns minutos seus créditos estarão disponíveis!",
}) {
  const [enableProgram, setEnableProgram] = useState(true);
  const [paymentWasSuccessful, setPaymentWasSuccessful] = useState(false);
  const [userAlreadyHasProgram, setUserAlreadyHasProgram] = useState(true);
  const [installments, setInstallments] = useState(0);
  const [selectedInstallment, setSelectedInstallment] = useState(1);

  async function checkUserAlreadyHasProgram() {
    setIsLoading(true);

    const response = await checkUserPlanProgram({
      msisdn,
      authToken,
    });

    const hasProgram =
      response.data.program?.filter((plan) => plan?.programID).length > 0;

    setUserAlreadyHasProgram(!!hasProgram);
    setIsLoading(false);
  }

  async function handleConfirmCVV() {
    const result = await Swal.fire({
      title: "Digite o CVV",
      input: "text",
      inputAttributes: {
        autocapitalize: "off",
        maxlength: 4,
        minlength: 3,
      },
      onOpen: (el) => {
        el.addEventListener("keyup", (e) => {
          e.target.value = e.target.value.replace(/[^\d]/, "");
        });
      },
      showCancelButton: false,
      confirmButtonText: "OK",
    });

    const cvv = result?.value;

    if (!cvv || cvv.trim().length < 3) {
      return notification("error", "CVV inválido");
    }
    try {
      setIsLoading(true);
      const response = await cardRechargeRequest({
        msisdn,
        paymentId: paymentData.paymentID,
        cvv,
        value: plan.value,
        authToken,
        program: enableProgram,
        installments: selectedInstallment,
      });
      setIsLoading(false);

      if (response.data.code !== "P00") {
        return notification("error", response.data.msg);
      }

      setPaymentWasSuccessful(true);

      await notification("success", successMessage);

      if (onPayment) onPayment(response.data);
    } catch (error) {
      console.log(error);
    }
  }

  async function getInstallmentsApi() {
    setIsLoading(true);
    const installmentInfo = await baseAPI.post("v1/GetParcelas", {
      transactionId: paymentData.transactionId,
      value: plan.value,
    });
    setInstallments(Number(installmentInfo.data.parcelas));
    setIsLoading(false);
  }

  const parseInstallmentsOptions = (quantity) => {
    const array = Array.from({ length: quantity }, (_, i) => i + 1).map(
      (value) => {
        if (plan.value > 100) {
          return {
            value,
            label:
              value === 1
                ? `À vista`
                : `${value}x de ${parseCentsToBRL(
                    (plan.value / value).toString()
                  )}`,
          };
        }

        return;
      }
    );

    return array;
  };

  useEffect(() => {
    getInstallmentsApi();
    checkUserAlreadyHasProgram();
  }, []);

  const planName = plan.name || `Alô ${plan.value.slice(0, 2)}`;

  return (
    <Styles.CreditCardReceiptContainer>
      <Styles.Receipt>
        <Styles.ReceiptItem>
          <header>
            <h2>Valor</h2>
            {allowChangeData && !paymentWasSuccessful && (
              <button onClick={() => onChangeStep(STEPS_NAME.CHOOSE_PLAN)}>
                Trocar
              </button>
            )}
          </header>
          {!plan.note ? (
            <h3>{planName}</h3>
          ) : (
            <img src={plan.note} alt={`Plano ${planName}`} />
          )}
        </Styles.ReceiptItem>

        <Styles.ReceiptItem>
          <header>
            <h2>Número</h2>
            {allowChangeData && !paymentWasSuccessful && (
              <button onClick={() => onChangeStep(STEPS_NAME.VERIFY_CLIENT)}>
                Trocar
              </button>
            )}
          </header>
          <h3>{parseMsisdn(msisdn)}</h3>
        </Styles.ReceiptItem>

        <Styles.ReceiptItem>
          <header>
            <h2>Pagamento</h2>
            {!paymentWasSuccessful && (
              <button onClick={() => onChangeStep(STEPS_NAME.CHOOSE_PAYMENT)}>
                Trocar
              </button>
            )}
          </header>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          ></div>
          <h3>
            <img
              src={require(`../../../images/payments/${paymentData?.flag.toLowerCase()}.svg`)}
              alt=''
            />
            Final {paymentData?.digFour}
          </h3>
          {installments > 1 && (
            <Styles.InstallmentsSelect>
              <label>Selecionar parcelas:</label>
              <select
                className='select-installment'
                onChange={({ target }) =>
                  setSelectedInstallment(parseInt(target.value))
                }
                defaultValue='1'
                placeholder='Selecione...'
              >
                {parseInstallmentsOptions(installments).map((option) => (
                  <option value={option.value}>{option.label}</option>
                ))}
              </select>
            </Styles.InstallmentsSelect>
          )}
        </Styles.ReceiptItem>
        <footer>
          <h2>Total</h2>
          <h3>{parseCurrency(plan.value)}</h3>
        </footer>
      </Styles.Receipt>
      {canMakeProgram && !userAlreadyHasProgram && (
        <>
          <Styles.ProgramCard>
            <div>
              <h4>Ativar Recarga programada</h4>
              <p>
                Com a recarga programada você ganha mais GBs de acordo com o seu
                plano escolhido, consulte o descritivo do plano. Acumule o que
                não usou para o próximo mês
              </p>
            </div>
            <label className='switch'>
              <input
                type='checkbox'
                checked={enableProgram}
                onChange={() => setEnableProgram(!enableProgram)}
                disabled={paymentWasSuccessful}
              />
              <span className='slider round'></span>
            </label>
          </Styles.ProgramCard>
          {infoMessage && <p>{infoMessage}</p>}
        </>
      )}
      <Styles.ConfirmButton
        rounded
        color='#1dbf00'
        onClick={handleConfirmCVV}
        disabled={paymentWasSuccessful}
      >
        {paymentWasSuccessful
          ? "Pagamento realizado com sucesso!"
          : "Confirmar"}
      </Styles.ConfirmButton>
    </Styles.CreditCardReceiptContainer>
  );
}
